import { createGlobalStyle, css } from 'styled-components';

export const CustomGlobalStyles = createGlobalStyle<{
  theme: any;
  gradientBackground?: boolean;
}>`
    ${({ theme, gradientBackground }) => css`
      body {
        background: ${theme.color.base.main};
      }

      ${gradientBackground &&
      css`
        body {
          background-image: linear-gradient(
            135deg,
            ${theme.color.primary.main},
            ${theme.color.primary.dark}
          );
        }
      `}

      fieldset label {
        color: ${theme.color.text.dark} !important;
      }
      fieldset {
        min-inline-size: inherit;
        padding: 0;
      }
      a {
        cursor: pointer;
      }

      ul {
        padding-left: ${theme.spacing.smMd};
        margin: 0;

        li {
          ${({ theme }) => css`
            padding-left: ${theme.spacing.xxs};
          `}
        }
      }

      input::-ms-reveal {
        display: none;
      }

      // 'strong' elements seem to have lost their strong properties for some reason
      // Adding this in to ensure strongs used site wide behave as expected
      strong {
        font-weight: bold;
      }
    `}
`;
